import styled, { css } from "styled-components"

export const InputDescription = styled.p`
  font-size: ${({ theme }) => theme.fonts.size.small};
`
InputDescription.defaultProps = {
  className: "tsr-input-description",
}

export const InputContainer = styled.div`
  position: relative;
  input {
    width: 100%;
    ${getInputError}
  }
`
InputContainer.defaultProps = {
  className: "tsr-input",
}

function getInputError({ theme, $hasError }) {
  if (!$hasError) return css``

  return css`
    border-color: ${theme.colors.alert.border};
    outline-color: ${theme.colors.alert.border};
  `
}

export const AuxText = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${getAuxStyle}
`

export const InnerContainer = styled.div`
  position: relative;
`

function getAuxStyle({ theme }) {
  const { small } = theme.spaces
  const { fg } = theme.colors.dimmed
  const { bg } = theme.colors

  return css`
    color: ${fg};
    right: ${small};
    background-color: ${bg};
  `
}
